import { ERROR_CODES } from "@zenith/data/constants";

export const getErrorTitle = (status?: number | string): string => {
  if (!status) return ERROR_CODES["connection_error"];

  return ERROR_CODES[status] || ERROR_CODES["network_error"];
};
